export const STATUS = [
    {name: 'GREEN', value: 'GREEN'},
    {name: 'BLACK', value: 'BLACK'},
    {name: 'RED', value: 'RED'},
    {name: 'YELLOW', value: 'YELLOW'}
];
